import React from "react";
import { Link } from "react-router-dom";
import { useBrand } from "../context/ThemeContext";

export default function Footer() {
  const { isSigns } = useBrand();
  return (
    <footer className="mt-24 border-t border-[#E2DDD5] bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2">
          {isSigns ? (
            <img src="/brand/kwik-signs.png" alt="Kwik Signs" className="h-9 w-auto mb-4" />
          ) : (
            <img src="/brand/kwik-stickers.png" alt="Kwik Stickers" className="h-9 w-auto mb-4" />
          )}
          <p className="text-sm text-slate-600 max-w-sm">By Kwik Kopy Shellharbour. {isSigns ? "Custom corflute, foamboard, PVC signs, pull-up banners, flags, A-Frames, media walls and coasters" : "Stickers on rolls, die-cut stickers and sticker sheets"}, printed locally and made to order.</p>
          <p className="text-sm text-slate-700 max-w-sm mt-3 font-semibold">Delivery across Australia or local pickup.</p>
        </div>
        <div>
          <div className="eyebrow mb-3">Kwik Stickers</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/stickers-on-rolls" className="hover:underline">Stickers on Rolls</Link></li>
            <li><Link to="/die-cut-stickers" className="hover:underline">Die-Cut Stickers</Link></li>
            <li><Link to="/stickers-on-sheets" className="hover:underline">Stickers on Sheets</Link></li>
          </ul>
          <div className="eyebrow mb-3 mt-6">Kwik Signs</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/corflute" className="hover:underline">Corflute Signs</Link></li>
            <li><Link to="/foamboard" className="hover:underline">Foamboard</Link></li>
            <li><Link to="/pvc" className="hover:underline">3mm PVC Signs</Link></li>
            <li><Link to="/pull-up-banners" className="hover:underline">Pull-Up Banners</Link></li>
            <li><Link to="/coasters" className="hover:underline">Custom Printed Coasters</Link></li>
            <li><Link to="/flags" className="hover:underline">Feather Flags</Link></li>
            <li><Link to="/a-frames" className="hover:underline">Aluminium A-Frames</Link></li>
            <li><Link to="/media-walls" className="hover:underline">Media Walls</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/how-it-works" className="hover:underline">How It Works</Link></li>
            <li><Link to="/about" className="hover:underline">About Us</Link></li>
            <li><Link to="/faq" className="hover:underline">FAQ</Link></li>
            <li><Link to="/admin" className="hover:underline text-slate-500">Admin</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#E2DDD5]">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 text-xs text-slate-500 flex flex-col sm:flex-row gap-2 justify-between">
          <div>© {new Date().getFullYear()} Kwik Kopy Shellharbour. Printed locally in Australia.</div>
          <div>All prices AUD, excluding GST unless clearly stated.</div>
        </div>
      </div>
    </footer>
  );
}
